import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createSuper";
import { ValueWithRandom } from "../../ValueWithRandom";
export var SplitRate = /*#__PURE__*/function (_ValueWithRandom) {
  _inherits(SplitRate, _ValueWithRandom);
  var _super = _createSuper(SplitRate);
  function SplitRate() {
    var _this;
    _classCallCheck(this, SplitRate);
    _this = _super.call(this);
    _this.value = {
      min: 4,
      max: 9
    };
    return _this;
  }
  return _createClass(SplitRate);
}(ValueWithRandom);